import styled from 'styled-components';

export const Div = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  grid-gap: 10px;

  .m-sub-title {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.cflowerBlue};
  }
  .m-sub-value {
    font-weight: 500;
  }
`;
